import IconGrid from 'components/common/IconGrid'
import ImageBox from 'components/common/ImageBox'
import { FC } from 'react'

export const psychologyProblems = [
  {
    href: '/psicologia-sexual-parceria/#sexual-disfunctions',
    icon: <ImageBox alt="off-icon" src="/icons/specialties/off-icon.svg" w="130px" h="130px" imgObjectFit="contain" />,
    label: 'Disfunções sexuais'
  },
  {
    href: '/psicologia-sexual-parceria/#low-libido',
    icon: (
      <ImageBox alt="icon-stats" src="/icons/specialties/icon-stats.svg" w="130px" h="130px" imgObjectFit="contain" />
    ),
    label: 'Baixa libido'
  },
  {
    href: '/psicologia-sexual-parceria/#betrayal',
    icon: <ImageBox alt="betrayal" src="/icons/specialties/betrayal.svg" w="130px" h="130px" imgObjectFit="contain" />,
    label: 'Lidar com a traição'
  },
  {
    href: '/psicologia-sexual-parceria/#swing',
    icon: <ImageBox alt="swing" src="/icons/specialties/swing.svg" w="130px" h="130px" imgObjectFit="contain" />,
    label: 'Swing e cuckolding'
  },
  {
    href: '/psicologia-sexual-parceria/#porn-addiction',
    icon: (
      <ImageBox alt="addiction" src="/icons/specialties/addiction.svg" w="130px" h="130px" imgObjectFit="contain" />
    ),
    label: 'Vício em pornô e masturbação'
  },
  {
    href: '/psicologia-sexual-parceria/#selfishness',
    icon: (
      <ImageBox alt="selfishness" src="/icons/specialties/selfishness.svg" w="130px" h="130px" imgObjectFit="contain" />
    ),
    label: 'Egoísmo e pressão'
  },
  {
    href: '/psicologia-sexual-parceria/#others',
    icon: (
      <ImageBox
        alt="other-problem"
        src="/icons/specialties/other-problem.svg"
        w="130px"
        h="130px"
        imgObjectFit="contain"
      />
    ),
    label: 'Outros problemas'
  }
]

const PathologiesGrid: FC = () => {
  return <IconGrid links={psychologyProblems} cardWidth="150px" />
}

export default PathologiesGrid
